/* Wischbare Bildergalerie (Theme-Assets): Pfeile, Punkte, Tastatur. Wischen läuft nativ über Scroll-Snap. */
(function () {
  if (window.customElements.get('fc-carousel')) return;

  class FcCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fc-carousel__track');
      this.slides = Array.from(this.querySelectorAll('.fc-carousel__slide'));
      this.dots = this.querySelector('.fc-carousel__dots');
      this.prev = this.querySelector('.fc-carousel__arrow--prev');
      this.next = this.querySelector('.fc-carousel__arrow--next');
      if (!this.track || this.slides.length < 2) {
        if (this.prev) this.prev.hidden = true;
        if (this.next) this.next.hidden = true;
        return;
      }

      this.index = 0;
      this.buildDots();
      this.prev.addEventListener('click', () => this.go(this.index - 1));
      this.next.addEventListener('click', () => this.go(this.index + 1));
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
      });

      let ticking = false;
      this.track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { ticking = false; this.sync(); });
      }, { passive: true });

      this.sync();
    }

    buildDots() {
      if (!this.dots) return;
      this.dots.innerHTML = '';
      this.dotButtons = this.slides.map((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fc-carousel__dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Bild ' + (i + 1));
        b.addEventListener('click', () => this.go(i));
        this.dots.appendChild(b);
        return b;
      });
    }

    go(i) {
      const n = this.slides.length;
      const target = Math.max(0, Math.min(n - 1, i));
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
    }

    sync() {
      const w = this.track.clientWidth || 1;
      this.index = Math.round(this.track.scrollLeft / w);
      const last = this.slides.length - 1;
      // Nachbarbilder vorladen, damit beim Wischen nichts leer bleibt.
      for (let i = Math.max(0, this.index - 1); i <= Math.min(last, this.index + 1); i++) {
        const img = this.slides[i].querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      }
      this.prev.disabled = this.index <= 0;
      this.next.disabled = this.index >= last;
      if (this.dotButtons) {
        this.dotButtons.forEach((b, i) => b.setAttribute('aria-selected', i === this.index ? 'true' : 'false'));
      }
    }
  }

  window.customElements.define('fc-carousel', FcCarousel);
})();
